import TransfersStatusModel from '../models/transferStatusModel';
import OrderModel from '../pages/order/models/orderModel';
import useAppContext from '../context/useAppContext';

/** Checks if we should allow the user to send emails or not
 * @returns {boolean}
 */
export function useIsEmailingBlocked() {
    const [{ event, organization }] = useAppContext();
    // Check the event and organisation that are already there
    let isBlocked = undefined;
    // No validated email
    if (!organization.organizer_has_validated_email) isBlocked = true;
    // moderated as good
    else if (event.spam_score <= 5) isBlocked = false;
    // moderated as spam
    else if (event.spam_score >= 100) isBlocked = true;
    // special whitelist
    else if (organization.isBrandTicketPro()) isBlocked = false;
    // Query more data if we don't have an answer
    const launch = isBlocked === undefined;
    const [status] = TransfersStatusModel.useApiModel(
        {
            launch,
            organizationId: organization.id
        },
        [organization.id, launch]
    );
    const [orders] = OrderModel.useApiModel(
        {
            launch,
            eventId: event.id,
            organizationId: organization.id,
            query: {
                limit: 1,
                origin__in: 'weez_web',
                order__status__in: 'valid,reservation'
            }
        },
        [launch, organization.id, event.id]
    );

    if (isBlocked !== undefined) {
        return isBlocked;
    }
    // wait for the results to load
    if (!status || !orders) return true; // Buttons should be disabled while we check
    // Missing orga info
    if (status.organisateur_info.status) return true;
    // Need at least one order
    if (!orders.length) return true;
    // ok otherwise
    return false;
}
